import React from 'react';

import RenderStaticHTML from '../RenderStaticHTML';

const Toggle = ({
	id, label, rootClassnames, disabled, checkboxRef, checked, handleChange, ...props
}) => {
	return (
		<label htmlFor={id} className={rootClassnames}>
			<input
				{...props}
				id={id}
				ref={checkboxRef}
				type={'checkbox'}
				checked={checked}
				onChange={handleChange}
				disabled={disabled}
			/>
			<span
				role={'slider'}
				aria-valuenow={checked === true ? 1 : 0}
				aria-label={'slider'}
				className={`toggle-slider`}
			/>
			<RenderStaticHTML
				html={label}
				as={`span`}
			/>
		</label>
	);
};

export default Toggle;
